import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityEditExpense = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8734 8.29688H2.16439C1.24517 8.29688 0.5 9.0421 0.5 9.96138V16.8275C0.5 17.7467 1.24517 18.492 2.16439 18.492H13.8734C14.7926 18.492 15.5378 17.7467 15.5378 16.8275V9.96138C15.5378 9.0421 14.7926 8.29688 13.8734 8.29688Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5625 8.29688V18.5003",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4105 12.0352H15.5382V15.5473H11.4105C10.4951 15.5473 9.74609 14.7982 9.74609 13.8828V13.6997C9.74609 12.7842 10.4951 12.0352 11.4105 12.0352Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.56445 8.29825L8.98068 3.82073C9.62979 3.37131 10.5119 3.51279 10.9863 4.14531L14.0904 8.30657H6.19283L11.3857 4.67795",
			stroke: "currentColor",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.674 0.523438C14.674 0.523438 15.14 3.61942 12.3105 5.7167",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4922 1.64019L14.6573 0.5L15.7641 1.63186",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3809 5.10154L16.7207 4.17773L17.6195 5.47605",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5288 5.07812C16.5288 5.07812 16.4289 7.04224 14.4316 7.97436",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgActivityEditExpense;
